var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isBSC)?_c('div',{staticClass:"referral-enter flex-all-center flex-column",on:{"click":_vm.openWool}},[_c('img',{attrs:{"src":require("@/assets/image/gold-egg.gif")}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }